import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ProductTranslationDataService } from '../../services/product-translation-data.service';
import { Language, LocalizedData, ProductTranslation } from '../../models/product-translation-data.models';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { createStructSDK } from '@structdk/extension-sdk';
import { RichTextEditorComponent } from '../../rich-text-editor.component';

@Component({
  selector: 'app-product-translation',
  imports: [FormsModule, CommonModule, RichTextEditorComponent],
  templateUrl: './product-translation.component.html',
  styleUrl: './product-translation.component.css',
})
export class ProductTranslationComponent implements OnInit {
  constructor(private productTranslationDataService: ProductTranslationDataService, private cdr: ChangeDetectorRef) {   
  }
  
  @ViewChild('productTranslationForm') form!: NgForm;

  languages: Language[] = [];
  model: ProductTranslation = {
    Description: [],
    Name: []   
  };
  originalModel!: ProductTranslation;
  productId: number = 0;
  working: boolean = false;

  ngOnInit(): void {  
    const struct = createStructSDK();

    let qp = new URLSearchParams(window.location.search);
    this.productId = Number(qp.get("entityid"));

    forkJoin({
      languages: this.productTranslationDataService.getLanguages(),
      modelData: this.productTranslationDataService.getData(this.productId),
    }).subscribe({
      next: (data) => {
        this.languages = data.languages;
        let model = data.modelData;

        for(let i = 0; i < this.languages.length;i++) {
          let language = this.languages[i];
          let itemName = model.Name.find(x => x.CultureCode === language.CultureCode);
          if (!itemName) {
            itemName = { CultureCode: language.CultureCode, Data: '' };
            this.model.Name.push(itemName);
          }

          let itemDesc = model.Description.find(x => x.CultureCode === language.CultureCode);
          if (!itemDesc) {
            itemDesc = { CultureCode: language.CultureCode, Data: '' };
            this.model.Description.push(itemDesc);
          }
        }

        this.model = model;
        this.originalModel = structuredClone(this.model);
    
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.cdr.detectChanges();
      }
    });
  }

  ngAfterViewInit() {
    this.form.valueChanges?.subscribe(() => {
      setTimeout(() => {
        const struct = createStructSDK();
        struct.actions.setIsDirtyState({ isDirty: this.hasChanges });
      }, 500);
    });
  }

  get hasChanges(): boolean {
    if(this.model.Name.length > 0){
      return JSON.stringify(this.model) !== JSON.stringify(this.originalModel);
    }
    return false;
  }

  getName(culture: string): LocalizedData {
    let item = this.model.Name.find(x => x.CultureCode === culture);    
    return item!;
  }

  getDescription(culture: string): LocalizedData {
    let item = this.model.Description.find(x => x.CultureCode === culture);
    return item!;
  }

  save(): void {
    this.working = true;
    const struct = createStructSDK();

    this.productTranslationDataService.updateData(this.productId, this.model).subscribe({
      next: (response) => {
        struct.actions.showSnackbarMessage({
          message: 'Product changes were saved',
          placement: 'top', // 'top' | 'bottom'
          isError: false,
          durationMs: 3000,    // optional
        });
        
        struct.actions.setIsDirtyState({ isDirty: false });
        struct.actions.refreshEditor();

        this.originalModel = structuredClone(this.model);
      
        this.working = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Lookup failed', error);
        this.cdr.detectChanges();
        this.working = false;
      }
    });

  }

  cancel(): void {
    this.model = structuredClone(this.originalModel);
    const struct = createStructSDK();
    struct.actions.setIsDirtyState({ isDirty: false });
  }
}
